import {
    mapActions,
    mapGetters,
    mapState
} from 'vuex';
import debounce from 'lodash/debounce';
export const cdbMixins = {
    data() {
        return {
            // cdb: [],
            params: {
                query: {
                    $limit: 100,
                    $sort: {
                        code: 1
                    }
                }
            },
        }
    },
    computed: {
        ...mapState('cdb', {
            cdbLoading: 'isFindPending'
        }),
        ...mapGetters('cdb', {
            findCdbInStore: 'find',
            getCdb: 'get'
        }),
        cdb() {
            return this.findCdbInStore(this.params).data;
        },
    },
    watch: {
        query: debounce(function (newVal) {
            this.queryItems();
        }, 400),
        parentId: debounce(function (newVal) {
            this.queryItems();
        }, 400),

        specialtyQuery: debounce(function (newVal) {
            if (newVal.length > 0) {
                this.params.query.specialty = newVal;
            } else {
                delete this.params.query.specialty;
            }
            this.queryItems();
        }, 400),
    },
    methods: {
        ...mapActions('cdb', {
            fetchCdb: 'find'
        }),


        queryItems() {
            if (this.query) {
                this.params.query.$or = [{
                        label: {
                            $regex: this.query,
                            $options: "i"
                        }
                    },
                    {
                        code: {
                            $regex: this.query,
                            $options: "i"
                        }
                    },
                    {
                        description: {
                            $regex: this.query,
                            $options: "i"
                        }
                    },
                ];
            } else {
                delete this.params.query.$or;
            }


            this.fetchCdb(this.params).then(result => {
                this.breadcrumbs = [];
                // this.cdb = result.data;
            });

        },
    }

}
